import * as ivsServices from '@/services/ivsServices';

export default {
  namespaced: true,
  state: {
    initialized: false,
    channel: {},
    streamKey: {}
  },
  mutations: {
    initStore(state, payload) {
      state.channel = payload.channel;
      state.streamKey = payload.streamKey;
      state.initialized = true;
    },
    updateStreamKey(state, streamKey) {
      state.streamKey = streamKey;
    }
  },
  actions: {
    async initStore({ commit }, payload) {
      const channel = await ivsServices.getChannel(payload.channelArn);
      const streamKey = await ivsServices.getStreamKey(payload.streamKeyArn);
      commit('initStore', { channel: channel, streamKey: streamKey });
    }
  },
  getters: {
    ableStartStreaming(state) {
      if (!state.channel.ingestEndpoint || !state.streamKey.value) {
        return false;
      }
      return true;
    },
    ableEndStreaming(state) {
      if (!state.channel.ingestEndpoint || !state.streamKey.value) {
        return false;
      }
      return true;
    }
  }
};
